import type { FileRoutesByTo } from '@/routeTree.gen'
import { createFileRoute, redirect, type RegisteredRouter } from '@tanstack/react-router'

export const redirectLegacyDomainDetail = ({
  params,
}: {
  params: { orgId: number; domainId: string }
}) => {
  // The destination owns parsing; forward this legacy route's raw domain id unchanged.
  throw redirect<RegisteredRouter, string>({
    to: '/$orgId/website/domains/$domainId' satisfies keyof FileRoutesByTo,
    params: { orgId: params.orgId, domainId: params.domainId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/domains/$domainId')({
  loader: redirectLegacyDomainDetail,
})
